export default {
  root: {
    width: 'fit-content',
    backgroundColor: '#FFFFFF'
  },
  loaderOverlay: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    background: '#FFF',
    opacity: '.5',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: '1px solid #EBEDF2',
    padding: '10px',
    '& button': {
      padding: '5px'
    }
  },
  dialogContent: { padding: 0 }
};
